import { type ApiInvoice, EnumInvoiceType, isApproved } from '@Model';
import { type Index, isLinked } from '@synqo/frontend-component-library';

// @ai-generated 2026-09-18T07:55:12+00:00 by philipp.kammerer@synqony.com using Claude Opus 5

/** A cancellation only takes a remark, an approved invoice keeps its payments open until one exists. */
export function forceReadOnly(
    partialInvoice: Pick<ApiInvoice, 'process_state' | 'type' | 'related_cancellation'>,
    name: string,
) {
    const index = name as Index<ApiInvoice>;
    if (partialInvoice.type === EnumInvoiceType.Cancellation) {
        if (isApproved(partialInvoice.process_state)) {
            return true;
        } else {
            const allowedProperties: Index<ApiInvoice>[] = ['remarks'];
            return !allowedProperties.includes(index);
        }
    }

    if (isApproved(partialInvoice.process_state)) {
        if (isLinked(partialInvoice.related_cancellation)) {
            return index !== 'remarks';
        } else {
            const allowedProperties: Index<ApiInvoice>[] = ['remarks', 'transactions'];
            return !allowedProperties.includes(index);
        }
    }
    return false;
}
